<template>
    <div class="devices-list">
        <el-header>
          <div>
            <el-button @click="refreshDevicesClicked" icon="el-icon-refresh" class="refresh-page" size="small"></el-button>
            <el-button @click="$router.push('/device-list-provision')"  class="refresh-page" size="small">Provisioning</el-button>
          </div>
            <div class="filters">
                <el-radio-group v-model="modeName" @change="modeChanged" size="mini" :disabled="loadingDevices">
                    <el-radio-button label="1Home Box"></el-radio-button>
                    <el-radio-button label="1Home Bridge"></el-radio-button>
                </el-radio-group>
                <el-input class="devices-search" type="text" v-model="searchValue" @keyup.enter.native="searchSubmit" size="mini" placeholder="Search by UUID / Internal IP / External IP" />
            </div>
            <div class="actions">
                
                <!-- <el-button @click="restartPageClicked" title="Restart all online devices on this page" size="small">Restart page</el-button> -->
                <el-button @click="restartAllClicked" title="Restart all online devices" size="small">Restart all</el-button>
                <el-button @click="updateAllClicked" :disabled="selectedMode === 'bridge'" title="Update all devices to the current release" size="small">Update all</el-button>
                <el-button @click="lockAll" :disabled="selectedMode === 'bridge'" title="Lock all devices to their current release" icon="el-icon-lock" size="small">Lock all</el-button>
            </div>
        </el-header>
        <el-main v-show="!loadingDevices">
            <el-table
                :data="tableData"
                style="width: 100%" stripe hover
                empty-text="No devices for this app"
                @row-click="devicePage"
                @sort-change="sortChanged"
                ref="dataTable"
                @selection-change="handleSelectionChange">
                <el-table-column
                    prop="status"
                    label="Status"
                    sortable="custom"
                    width="90">
                    <template v-slot="scope">
                        <i v-if="scope.row.status=='Online'" class="el-icon-success" style="color:#00b825;font-size:26px;"/>
                        <i v-if="scope.row.status=='Offline'" class="el-icon-error" style="color:#e61717;font-size:26px;"/>
                    </template>
                </el-table-column>
                <el-table-column
                    type="selection"
                    width="55">
                </el-table-column>
                <el-table-column prop="device_name" label="Name" sortable="custom">
                    <template v-slot="scope">
                        <b><a class="name-link" @click.stop="" :href="`/device/${scope.row.uuid}`">{{ scope.row.device_name }}</a></b>
                    </template>
                    <!-- <template v-slot="scope">
                        <el-button
                        type="text"
                        size="small"
                        @click="devicePage(scope.row)">
                            {{ scope.row.device_name }}
                        </el-button>
                    </template> -->
                </el-table-column>
                <el-table-column prop="uuid" label="UUID" sortable="custom">
                    <template v-slot="scope">
                        {{ selectedMode === 'box' ? callSliceString(scope.row.uuid) : scope.row.uuid }}
                        <i class="el-icon-document-copy" @click.stop="copy(scope.row.uuid)" />
                    </template>
                </el-table-column>
                <el-table-column
                    prop="ip_address"
                    label="IP Address" sortable="custom">
                </el-table-column>
                <el-table-column
                    prop="last_seen"
                    label="Last Seen">
                    <template v-slot="scope">
                        {{ printDate(scope.row.last_seen)}}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="created_at"
                    label="Created at"
                    sortable="custom">
                    <template v-slot="scope">
                        {{ printDate(scope.row.created_at)}}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="device_type"
                    label="Device type" sortable="custom">
                </el-table-column>
                <!-- <el-table-column
                prop="os_variant"
                label="Os Variant" sortable>
                    <template v-slot="scope">
                        <span id="os-variant">
                            {{ scope.row.os_variant}}
                        </span>
                    </template>
                </el-table-column> -->
                <el-table-column prop="release" label="Release" sortable="custom">
                    <template v-slot="scope">
                        {{ callSliceString(scope.row.release) }}
                        <i v-if="scope.row.tracking === false" class="el-icon-lock" />
                        <!-- <i v-if="scope.row.release" class="el-icon-document-copy" @click.stop="copy(scope.row.release)" /> -->
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    :current-page.sync="currentPage"
                    :page-size="pageSize"
                    :total="getDevices.all ? getDevices.all.length : 0">
                </el-pagination>
            </div>
        </el-main>
        <div v-if="loadingDevices" class="loading modal">
            <i class="el-icon-loading"></i>
        </div>
        <div v-if="lockAllInProgress" class="lock-all-devices modal">
            <i class="el-icon-loading"></i>
            <span class="text">Locking device: {{lockAllCurrent}}/{{getDevices.all.length}}</span>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions, mapMutations } from 'vuex';
    import { sliceString, copyToClipboard } from './../utils/my_module'
    import config from './../config/config'
    import { setTimeout } from 'timers';
    import { pinToRelease, lockOverride, getAppReleases, restartApp } from './../api'

    export default {
        name: 'DevicesList',
        data () {
            return {
                loadingDevices: false,
                modeName: '1Home Box',
                appsData: {
                    'voxiorApp': {name: 'voxiorApp', id: 9}
                },
                firstLoad: true,
                currentPage: 1,
                pageSize: 12,
                multipleSelection: [],
                predictions: [],
                searchValue: '',
                lockAllInProgress: false,
                lockAllCurrent: 1,
            }
        },
        methods: {
            ...mapMutations([
                'setDevices'
            ]),
            ...mapActions([
                'fetchDevices',
                'fetchApps',
                'updateAll'
            ]),
            filterDevices() {
              let searchValue = this.searchValue.toLowerCase()
              searchValue = searchValue.replace(/knxbridge/g, 'knxBridge')
              
                this.loadingDevices = true;
                return this.fetchDevices({mode: this.selectedMode, searchValue})
                    .then(res => {
                        this.loadingDevices = false;
                    })
            },
            searchSubmit() {
                if (this.searchValue.includes('1HomeBox_')) this.searchValue = this.searchValue.split('_')[1]
                this.filterDevices();
            },
            devicePage(deviceData) {
                this.$router.push('/device/' + deviceData.uuid);
                // this.$router.push({ name: 'Device', query: { uuid: deviceInfos.uuid } });
            },
            callSliceString(str) {
                return sliceString(str)
            },
            copy(element) {
                copyToClipboard(element);
                this.$notify({
                    message: 'Copied ' + element,
                    type: 'success',
                    position: 'bottom_left'
                });
            },
            refreshDevicesClicked() {
                // window.localStorage.removeItem('search-value');
                // window.localStorage.removeItem('sort');
                this.searchValue = '';
                this.$refs.dataTable.clearSort();
                this.refreshDeviceList();
            },
            refreshDeviceList() {
                this.loadingDevices = true;
                this.filterDevices()
                    .then(() => {
                        this.loadingDevices = false;
                    })
                    .catch((err) => {
                        this.$message.error(`${err.message}`);
                        console.log(err);
                    })
            },
            printDate(dateStr, time = true) {
                //if (!dateStr || dateStr.split('-').length < 3) return dateStr;
                let date = new Date(dateStr);
                return `${date.getDate()}.${date.getMonth()+1}.${date.getFullYear()}` + (time ? ` - ${this.leadingZero(date.getHours())}:${this.leadingZero(date.getMinutes())}:${this.leadingZero(date.getSeconds())}` : '');
            },
            leadingZero(num) {
                var s = num+"";
                while (s.length < 2) s = "0" + s;
                return s;
            },
            sortChanged(data) {
                let sort = {};
                sort.prop = data.prop;
                sort.order = data.order;
                // window.localStorage.setItem('sort', JSON.stringify(sort));

                if (!data.order) return;

                let devices = this.getDevices;
                if (data.prop === 'created_at') {
                    devices.all.sort((a, b) => {
                        let dateA = new Date(a.created_at);
                        let dateB = new Date(b.created_at);
                        if (data.order === 'ascending') {
                            return dateA.getTime() > dateB.getTime() ? 1 : -1;
                        } else if (data.order === 'descending') {
                            return dateA.getTime() < dateB.getTime() ? 1 : -1;
                        }
                    });
                } else {
                    if (data.order === 'ascending') {
                        devices.all.sort((a, b) => (a[data.prop] > b[data.prop]) ? 1 : -1);
                    } else {
                        devices.all.sort((a, b) => (a[data.prop] < b[data.prop]) ? 1 : -1);
                    }
                }

                this.setDevices(devices);
            },
            lockAll() {
                if (confirm("Are you sure you want to lock all devices to their current release? This will take a couple of minutes.")) {
                    this.lockAllInProgress = true;
                    this.getDevices.all.map(device => {
                        pinToRelease(device.uuid, device.release)
                            .then(res => {
                                this.lockAllCurrent++;
                                if (this.lockAllCurrent > this.getDevices.all.length) {
                                    this.lockAllInProgress = false;
                                    this.lockAllCurrent = 1;
                                }
                            })
                            .catch(err => {
                                this.$message.error(err.message);
                            })
                    })
                }
            },
            async updateAllClicked() {
                if (confirm("Are you sure you want to update all devices to the current release?")) {
                    let appId = this.appsData.voxiorApp.id
                    let rel = await getAppReleases(appId);
                    let latestRelease = rel.message[0].commit;
                    if (latestRelease) {
                        let uuids = this.getDevices.all.filter(d => d.release !== latestRelease).map(device => {
                            return device.uuid;
                        })
                        this.updateAll({uuids: uuids, release: latestRelease});
                    }
                }
            },
            restartAllClicked() {
                if (confirm("Do you want to restart apps of all devices?")) {
                    let uuids = this.getDevices.all.filter(d => d.status === 'Online').map(async device => {
                        let restart = await restartApp(device.uuid, device.appId);
                        if (restart.success) {
                            this.$notify({
                                message: device.uuid.substring(0,7) + ' restarted.',
                                type: 'success',
                                position: 'bottom_left'
                            })
                        } else {
                            this.$notify({
                                message: restart.message,
                                type: 'error',
                                position: 'bottom_left'
                            })
                        }
                    })                    
			    }
            },
            sortData(prop, order) {
                this.$refs.dataTable.sort(prop, order);
            },
            handleSelectionChange(val) {
                this.multipleSelection = val.map(device => {
                    return device.uuid;
                });
                console.log('SELECTION', this.multipleSelection);
            },
            modeChanged() {
                window.localStorage.setItem('mode', this.selectedMode);
                this.filterDevices()
            }
        },
        computed: {
            ...mapGetters([
                'getDevices',
                'getApps'
            ]),
            tableData() {
                if (this.getDevices.all) {
                    return this.getDevices.all.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
                } else {
                    return [];
                }
            },
            selectedMode() {
                return this.modeName === '1Home Box' ? 'box' : 'bridge'
            }
        },
        created: function() {
            
        },
        mounted() {
            window.localStorage.setItem('mode', 'box');
            this.refreshDeviceList();
        },
        watch: {
        },
        beforeDestroy() {
        }
    }
</script>

  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>

    h1, h2 {
        font-weight: normal;
    }
    ul {
        list-style-type: none;
        padding: 0;
    }
    li {
        display: inline-block;
        margin: 0 10px;
    }
    a {
        color: #42b983;
    }
    .name-link{
      color: black;
      text-decoration: none;
    }
    #os-variant {
        background: green;
        color: white;
        border-radius: 8px;
        padding-left: 0.4em;
        padding-right: 0.4em;
    }
    .button-copy-to-clipboard {
        background-color: transparent;
        border: none;
        cursor: pointer;
    }
    .el-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color: #34495e;
    }
    .el-main {
        padding: 0;
        cursor: pointer;
    }
    .filters {
        display: flex;
        align-items: center;
    }

    .predicted-device {
        color: #404040;
        background-color: rgb(250, 250, 250);
        cursor: pointer;
        border: 2px solid #d1cfcf;
        border-radius: 15px;
    }
    .predicted-device:hover {
        background-color: #e7e7e7;/* rgb(216, 216, 216);*/
    }
    .devices-search {
        margin-left: 20px;
    }
    .devices-search,
    .app-select {
        width: 200px;
    }
    .el-icon-document-copy {
        margin-left: 3px;
        cursor: pointer;
    }
    .el-table__row {
        
    }
    .pagination {
        padding: 30px 0 40px;
    }

    .lock-all-devices,
    .loading.modal {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(255, 255, 255, 0.8);
    }
    .loading.modal {
        top: 60px;
    }
    .lock-all-devices .text {
        font-weight: bold;
    }
    .lock-all-devices .el-icon-loading,
    .loading.modal .el-icon-loading {
        font-size: 30px;
        margin-bottom: 10px;
    }

</style>


// WEBPACK FOOTER //
// src/components/DevicesList.vue